'use client';

import React from 'react';
import {
  Spinner as PolarisSpinner,
  SpinnerProps as PolarisSpinnerProps,
} from '@shopify/polaris';

interface Props extends PolarisSpinnerProps {}

const Spinner: React.FC<Props> = ({ accessibilityLabel, size }) => (
  <div className="flex h-full items-center justify-center">
    <PolarisSpinner accessibilityLabel={accessibilityLabel} size={size} />
  </div>
);

export default Spinner;
